module.exports = __webpack_public_path__ + "img/design proposal_demo-03.2fc1527a.jpg";